// extracted by mini-css-extract-plugin
module.exports = {"root":"__404_root__UNI9H","info":"__404_info__7dRQo","background":"__404_background__qaPUy","errorCode":"__404_errorCode__tmRkB","text":"__404_text__dJgHx"};